import { SetRequired } from 'type-fest';

import { Audience_Purchase_Time_Window } from '@occc/graphql';
import { parseDate } from '@occc-app/lib/date';
import { PeriodOfThePurchaseForQualifiedEvents, TimePeriod } from '../../types';

type PeriodValues = {
  relativeMonthsBack?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  targetMonth?: number | null;
  targetYear?: number | null;
  timeWindow?: Audience_Purchase_Time_Window | null;
};

type RollingWindowPeriod = SetRequired<
  Partial<PeriodOfThePurchaseForQualifiedEvents>,
  'timeWindow'
> & {
  timePeriodType: TimePeriod.RollingWindow;
};

type FixedWindowPeriod = SetRequired<
  Partial<PeriodOfThePurchaseForQualifiedEvents>,
  'fixedWindow'
> & {
  timePeriodType: TimePeriod.FixedWindow;
};

type PreviousMonthPeriod = Partial<PeriodOfThePurchaseForQualifiedEvents> & {
  timePeriodType: TimePeriod.PreviousMonth;
};

export type TimePeriodFormValues = RollingWindowPeriod | FixedWindowPeriod | PreviousMonthPeriod;

export const convertDateConditionToInitialFormValues = ({
  startDate,
  endDate,
  timeWindow,
}: PeriodValues): TimePeriodFormValues => {
  const isRollingWindow = !!timeWindow;
  const isFixedWindow = !!(startDate && endDate);

  if (isRollingWindow) {
    return {
      timePeriodType: TimePeriod.RollingWindow,
      timeWindow,
    };
  }

  if (isFixedWindow) {
    return {
      timePeriodType: TimePeriod.FixedWindow,
      fixedWindow: {
        startDate: parseDate(startDate),
        endDate: parseDate(endDate),
      },
    };
  }
  return {
    // To implement relativeMonthsBack we hardcode this value to 1 on the FE side
    // This why we don't need it to be stored in the form values
    timePeriodType: TimePeriod.PreviousMonth,
  };
};
